const footerLinks = [
  { label: 'Docs', href: '/docs' },
  { label: 'Security', href: '/security' },
  { label: 'Skills', href: '/skills' },
  { label: 'Compare', href: '/compare' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Terms of Service', href: '/terms-of-service' },
  { label: 'Discord', href: 'https://discord.gg/xEKNgxjX' },
];

const Footer = () => {
  return (
    <footer className="border-t border-border px-6 py-12">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 md:flex-row md:justify-between">
        <div className="flex items-center gap-2.5">
          <div className="flex h-7 w-7 items-center justify-center rounded-md bg-primary text-xs font-bold text-primary-foreground">
            .t
          </div>
          <div>
            <span className="tasking-wordmark text-sm font-semibold text-foreground">
              tasking<span className="text-primary">.tech</span>
            </span>
            <p className="text-[11px] text-muted-foreground">
              Agentic AI platform for autonomous task execution and team collaboration.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {footerLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-xs text-muted-foreground transition-colors hover:text-foreground"
            >
              {link.label}
            </a>
          ))}
        </div>

        <p className="text-xs text-muted-foreground">
          (c) {new Date().getFullYear()} Tasking.tech. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
